<template>
  <vx-card v-show="isCardActiveLocal" :style="{ 'background-color': question && question.quizDetails.isGraded ? 'rgba(255, 204, 0, 0.3)' : 'none', 'margin-bottom': '1rem' }">
    <div class="vx-row free-text" style="margin-left:unset">
      <div class="vx-col w-full">
        <h5 class="mb-2">{{ answer.questionNumber }}. {{ questionTitle }}</h5>
        <p class="mb-2" v-html="questionText"></p>
        <div v-if="answer.imageUrl" class="vx-row mb-3">
          <div class="vx-col w-full">
            <img :src="answer.imageUrl" height="200px" alt="Question Image">
          </div>
        </div>
        <span>Answer: <span :style="{'font-weight': 700 }" v-html="answer.inputAnswer"></span></span>
        <p v-if="question.quizDetails.isGraded"><span>Correct Answer(s): <span :style="{'color': '#00cc00' }">{{ answer.textCorrectAnswer }}</span></span></p>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :answer="answer" :predefinedComments="predefinedComments" />
  </vx-card>
</template>

<script>
  import commentView from './QuizCommentView.vue';
  export default {
    components: {
      commentView
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      answer: {
        type: Object,
        required: false
      },
      predefinedComments: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        commentView: true,
        questionText: "",
        questionTitle: ""
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      setOptionColor(option, answer) {
        if(option.isCorrectAnswer){
          return '#00cc00';
        }
        else if(answer.inputAnswer == option.optionNumber.toString()){
          return 'red';
        }
        else{
          return this.$store.state.theme == 'dark' ? '#c5c5c5' : 'black';
        }
      },
      setOptionFont(optionIndex, option, answer) {
        if((optionIndex + 1) == answer.inputAnswer && answer.inputAnswer == option.optionNumber.toString())
          return 700;
        else if((optionIndex + 1) == answer.inputAnswer && answer.inputAnswer != option.optionNumber.toString())
          return 700;
        else
          return 400;
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
    },
    mounted() {
      if(this.answer){
        this.questionText = (this.answer.questionText);
        this.questionTitle = (this.answer.questionTitle);
      }
    }
  }

</script>

<style lang="scss">
.free-text{

  ul{
    li{
      list-style-type: square;
    }
  }

  ol{
    li{
      list-style-type:decimal;
    }
  }

}
</style>
